import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import "../App.css";
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, deleteDoc, doc, updateDoc, setDoc, where, getCountFromServer } from 'firebase/firestore'
import moment from 'moment';

export default function Products() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [userData, setUserData] = useState();
    const [departments, setdepartments] = useState([]);
    const [searchText, setsearchText] = useState("");
    const [products, setproducts] = useState([]);
    const [departmentid, setdepartmentid] = useState("");
    const [product, setproduct] = useState("");

    const [updocid, setupdocid] = useState("");
    const [updepartmentid, setupdepartmentid] = useState("");
    const [upproduct, setupproduct] = useState("");

    // ✅ Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
    }, []);

    const fetchData1 = async () => {
        try {
            // Fetch Departments in real-time
            const departmentsQuery = query(collection(db, 'departments'), orderBy("createdAt", "asc"));
            onSnapshot(departmentsQuery, (departmentsSnapshot) => {
                setdepartments(departmentsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });

            // Fetch Products in real-time
            const productsQuery = query(collection(db, 'products'), orderBy("product", "asc"));
            onSnapshot(productsQuery, async (productsSnapshot) => {
                const products = productsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data(),
                    departmentid: doc.data().departmentid
                }));

                const departmentids = [
                    ...new Set(
                        products
                            .map(detail => detail.departmentid)
                            .filter(id => id) // ✅ remove null/undefined/empty
                    )
                ];
                const docRefs = departmentids.map(id => doc(db, "departments", id));
                const docSnaps = await Promise.all(docRefs.map(docRef => getDoc(docRef)));

                const departmentMap = {};
                docSnaps.forEach((docSnap, index) => {
                    if (docSnap.exists()) {
                        departmentMap[departmentids[index]] = docSnap.data().department;
                    }
                });

                const combinedData = products.map(detail => ({
                    id: detail.id,
                    data: detail.data,
                    department: detail.departmentid
                        ? (departmentMap[detail.departmentid] || "")
                        : "" // ✅ if no departmentid, show blank
                }));

                setproducts(combinedData);
                setCurrentPage(1); // reset to first page after fetch
            });

        } catch (error) {
            Toast.fire({ icon: "error", title: error.message });
            console.error(error.message);
        }
    };

    const fetchData2 = async () => {
        try {
            const filteredData = products.filter((item) => {
                const roomNumber = String(item.data.product).toUpperCase();
                return roomNumber.includes(searchText.toUpperCase());
            });
            setproducts(filteredData);
            setCurrentPage(1);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleSubmit = async () => {
        if (!product || !departmentid) {
            Toast.fire({ icon: "error", title: 'Please fill all the fields!!' });
            return;
        }

        await addDoc(collection(db, 'products'), {
            departmentid,
            product,
            uid: userData.uid,
            created: Timestamp.now()
        });

        const q = query(collection(db, 'products'), where('departmentid', '==', departmentid));
        const snapshot = await getCountFromServer(q);

        await updateDoc(doc(db, "departments", departmentid), {
            noofrooms: snapshot.data().count,
        });

        setproduct("");
        Toast.fire({ icon: "success", title: 'Store Product Added Successfully!!' });
    };

    const handleDelete = async (docid) => {
        await deleteDoc(doc(db, 'products', docid));
        Toast.fire({ icon: "success", title: 'Store Product Deleted Successfully!!' });
        fetchData1();
    };

    const handleEdit = (id, departmentid, product) => {
        setupdocid(id);
        setupproduct(product);
        setupdepartmentid(departmentid);
    };

    const handleUpdate = async () => {
        if (!upproduct || !updepartmentid) {
            Toast.fire({ icon: "error", title: 'Please fill all the fields!!' });
            return;
        }

        await setDoc(doc(db, "products", updocid), {
            departmentid: updepartmentid,
            product: upproduct,
            uid: userData.uid,
            created: Timestamp.now()
        });

        Toast.fire({ icon: "success", title: 'Store Product Updated Successfully!!' });
        fetchData1();
    };

    // ✅ Pagination logic
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentItems = products.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(products.length / itemsPerPage);

    return (
        <div>
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right" }} >|| Store Product ||</button>
                        <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Add Store Product</button><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Department</th>
                                            <th>Product Name</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            currentItems.map((item, index) =>
                                                <tr key={item.id}>
                                                    <td width="80">{indexOfFirst + index + 1}</td>
                                                    <td>{item.department} </td>
                                                    <td>{item.data.product}</td>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.data.departmentid, item.data.product)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>

                                {/* ✅ Pagination Controls */}
                                <div className="d-flex justify-content-between align-items-center p-2">
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                    >
                                        Prev
                                    </button>
                                    <span> Page {currentPage} of {totalPages} </span>
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ================= Insert Modal ================= */}
            <div className="modal fade" id="insert-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Store Product</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>Department</label>
                                    <select value={departmentid} onChange={(e) => setdepartmentid(e.target.value)} className="form-control" >
                                        <option value=""></option>
                                        {
                                            departments.map((item, index) =>
                                                <option key={index} value={item.id}>{item.data.department}</option>
                                            )
                                        }
                                    </select>
                                </div>
                                <div className="col-sm-6">
                                    <label>  Product Name</label>
                                    <input type="text" value={product} onChange={(e) => setproduct(e.target.value)} className="form-control" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="submit" onClick={() => handleSubmit()} className="btn btn-primary" >Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= Edit Modal ================= */}
            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Store Product</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>Department</label>
                                    <select value={updepartmentid} onChange={(e) => setupdepartmentid(e.target.value)} className="form-control" >
                                        <option value=""></option>
                                        {
                                            departments.map((item, index) =>
                                                <option key={index} value={item.id}>{item.data.department}</option>
                                            )
                                        }
                                    </select>
                                </div>
                                <div className="col-sm-6">
                                    <label>  Product Name</label>
                                    <input type="text" value={upproduct} onChange={(e) => setupproduct(e.target.value)} className="form-control" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
